import { CAREER_START } from '../utils/yearsOfExperience';

/**
 * Skill start dates: annual tiers on July 1, measured from CAREER_START (2019-07-01).
 * Tier names match the years listed on the CV (Sep 2026): "7y" skills → career start; "6y" → +1 year; … "1y" → +6 years.
 * Decimal years update automatically in the browser (no redeploy to bump 7.x).
 * Skills no longer in active use take a fixed `years` instead of a `start` date.
 */
const T = {
  y7: CAREER_START,
  y6: '2020-07-01',
  y5: '2021-07-01',
  y4: '2022-07-01',
  y3: '2023-07-01',
  y2: '2024-07-01',
  y1: '2025-07-01',
};

/**
 * Items without `start` or `years` render as a tag (no years bar).
 * The first section is the "core stack" highlighted across the site.
 */
export const skillSections = [
  {
    title: 'Core Stack:',
    items: [
      { label: 'React.js', start: T.y7 },
      { label: 'Node.js', start: T.y5 },
      { label: 'Next.js', start: T.y4 },
      { label: 'TypeScript', start: T.y3 },
      { label: 'Angular', start: T.y3 },
      { label: 'React Native', start: T.y3 },
    ],
  },
  {
    title: 'AI & LLM Engineering:',
    items: [
      { label: 'OpenAI APIs (production)', start: T.y1 },
      { label: 'LLM-Powered Features', start: T.y1 },
      { label: 'Prompt Engineering', start: T.y2 },
      { label: 'AI-Assisted Development', start: T.y2 },
      { label: 'GitHub Copilot', start: T.y1 },
      { label: 'Agentic Workflows & Sub-Agents', start: T.y1 },
      { label: 'LangChain' },
      { label: 'LangGraph' },
      { label: 'RAG & Structured Output' },
    ],
  },
  {
    title: 'Frontend:',
    items: [
      { label: 'JavaScript', start: T.y7 },
      { label: 'HTML5 & CSS3', start: T.y7 },
      { label: 'Redux', start: T.y6 },
      { label: 'Redux Saga', start: T.y4 },
      { label: 'MobX', start: T.y3 },
      { label: 'RxJS', start: T.y3 },
      { label: 'Microfrontend', start: T.y3 },
      { label: 'Monorepo', start: T.y3 },
      { label: 'Material UI', start: T.y4 },
      { label: 'Tailwind CSS', start: T.y4 },
      { label: 'SASS', start: T.y4 },
      { label: 'Webpack', start: T.y4 },
      { label: 'Localization & Arabic RTL', start: T.y4 },
      { label: 'Ant Design', start: T.y5 },
      { label: 'Bootstrap', start: T.y5 },
      { label: 'Microsoft Dynamics 365 Commerce', years: 1 },
    ],
  },
  {
    title: 'Backend & Data:',
    items: [
      { label: 'REST APIs', start: T.y7 },
      { label: 'MongoDB', start: T.y5 },
      { label: 'PostgreSQL', start: T.y4 },
      { label: 'Redis', start: T.y4 },
      { label: 'GraphQL', start: T.y3 },
      { label: 'Firebase', start: T.y3 },
      { label: 'MySQL', start: T.y2 },
      { label: 'RabbitMQ', start: T.y2 },
      { label: 'Kafka', start: T.y1 },
      { label: '.NET', start: T.y1 },
      { label: 'OpenAPI (Swagger)', start: T.y1 },
      { label: 'Java & Spring Boot' },
    ],
  },
  {
    title: 'Testing & Quality:',
    items: [
      { label: 'Jest', start: T.y5 },
      { label: 'React Testing Library', start: T.y3 },
      { label: 'Cypress', start: T.y2 },
      { label: 'Playwright', start: T.y2 },
      { label: 'SonarQube', start: T.y1 },
      { label: 'Checkmarx', start: T.y1 },
      { label: 'Code Reviews & Mentoring', start: T.y2 },
    ],
  },
  {
    title: 'Cloud & Delivery:',
    items: [
      { label: 'Git & GitHub', start: T.y7 },
      { label: 'Agile & Scrum', start: T.y7 },
      { label: 'Jira', start: T.y7 },
      { label: 'Docker', start: T.y4 },
      { label: 'AWS', start: T.y3 },
      { label: 'CI/CD', start: T.y3 },
      { label: 'GitLab & Bitbucket', start: T.y2 },
      { label: 'Azure DevOps', start: T.y1 },
      { label: 'Akamai CDN', start: T.y1 },
    ],
  },
];
